import { ReactElement } from 'react';
import { IonPage, IonTab, IonTabs } from '@ionic/react';
import Footer from '../components/footers/Footer';
import HomeTab from '../pages/tabs/home';
import MenuTab from '../pages/tabs/menu';
import OrdersTab from '../pages/tabs/orders';
import IonProvider from '../providers/IonProvider';
import { Tabs } from '../exports/Enums';
import useMobileRouter from '../common/hooks/useMobileRouter';
import useWatchOffers from '../../../features/offers/hooks/useWatchOffers';

const MainLayout = (): ReactElement => {
  useWatchOffers();

  const { setTab } = useMobileRouter();

  return (
    <IonProvider>
      <IonPage>
        <IonTabs onIonTabsDidChange={(e) => setTab(e.detail.tab as Tabs)}>
          <IonTab tab={Tabs.Home}>
            <HomeTab />
          </IonTab>
          <IonTab tab={Tabs.Menu}>
            <MenuTab />
          </IonTab>
          <IonTab tab={Tabs.Orders}>
            <OrdersTab />
          </IonTab>
          <Footer />
        </IonTabs>
      </IonPage>
    </IonProvider>
  );
};

export default MainLayout;
